export default (state = {}, {}) => {
  return {
    ...state,
    allReportState: {},
    allReportData: {},
    allReportMeta: {},
    allReportRecordData: {},
    allReferralReport: {},
  };
};
